export default {
  namespaced: true,

  state: () => ({
    blocks: [],
    start: new Date().toISOString(),
    end: new Date().toISOString(),
    id: 0,
    url: '',
    productTiles: {},
    mediaBanners: {},
  }),

  actions: {
    async fetchCLP({ commit }, { clpId, territoryId }) {
      const {
        blocks,
        start,
        end,
        id,
        url,
      } = await this.$apiBFF.getCLP({ clpId, territoryId });

      commit('setBlocks', blocks);
      commit('setStart', start);
      commit('setEnd', end);
      commit('setId', id);
      commit('setUrl', url);
    },
    async fetchCatalogProductTiles({ commit }, { id, productIds = [], onlyAvailableProducts = false }) {
      if (!productIds.length) return;

      const data = await this.$apiBFF.fetchCatalogProductTiles({ productIds, onlyAvailableProducts });

      if (!data.length) return;
      commit('setProductTiles', { id, data });
    },
    async fetchMediaBanners({ commit }, { slots, categoryId }) {
      if (!categoryId) return;

      const data = await this.$apiBFF.fetchMediaBanners({ slots, categoryId });

      if (data.length) {
        commit('setMediaBanners', {
          key: `${slots}${categoryId}`,
          mediaBanners: data?.[0]?.content,
        });
      }
    },
  },

  mutations: {
    setBlocks(state, blocks = []) {
      state.blocks = blocks;
    },
    setStart(state, start) {
      state.start = start;
    },
    setEnd(state, end) {
      state.end = end;
    },
    setId(state, id) {
      state.id = id;
    },
    setUrl(state, url) {
      state.url = url;
    },
    setProductTiles(state, { id, data }) {
      state.productTiles[id] = data;
    },
    setMediaBanners(state, { key = '', mediaBanners = [] }) {
      state.mediaBanners[key] = mediaBanners;
    },
  },
};
